export const isCommandKey = event => {
  try {
    if (!event) return false;

    return event.ctrlKey || event.metaKey || event.key === 'Meta' || event.key === 'Control';
  } catch (_) {
    return false;
  }
};
